import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-modern-schooling-courses',
  templateUrl: './modern-schooling-courses.component.html',
  styleUrls: ['./modern-schooling-courses.component.scss']
})
export class ModernSchoolingCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
